import { getAxiosInstance } from '../configs/axios-config';
var constants = require("../configs/constants");
const LOGIN_PROGRESS = "LOGIN_PROGRESS";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGIN_FAILURE = "LOGIN_FAILURE";
const MOB_VERIFY_SUCCESS = "MOB_VERIFY_SUCCESS";
const MOB_VERIFY_FAILURE = "MOB_VERIFY_FAILURE";
const OTP_VERIFY_SUCCESS = "OTP_VERIFY_SUCCESS";
const OTP_VERIFY_FAILURE = "OTP_VERIFY_FAILURE";
const SEND_FORGET_CASE = "SEND_FORGET_CASE";
const HIDE_LOGIN_SNACKBAR = "HIDE_LOGIN_SNACKBAR";
const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";

export const loginInProgress = (loginData) => { return { type: LOGIN_PROGRESS, loginData: loginData } }
export const loginSuccess = (loginData) => { return { type: LOGIN_SUCCESS, loginData: loginData } }
export const loginFailure = (loginData, errorMessage) => { return { type: LOGIN_FAILURE, loginData: loginData, message: errorMessage } }
export const mobVerifySuccess = (mobData, successMsg) => { return { type: MOB_VERIFY_SUCCESS, mobData: mobData, successMsg: successMsg } }
export const mobVerifyFailure = (errorMsg) => { return { type: MOB_VERIFY_FAILURE, message: errorMsg, } }
export const otpVerifySuccess = (otpData, successMsg) => { return { type: OTP_VERIFY_SUCCESS, otpData: otpData, successMsg: successMsg } }
export const otpFailure = (errorMsg) => { return { type: OTP_VERIFY_FAILURE, message: errorMsg } }
export const returnProfile = (caseData) => { return { type: SEND_FORGET_CASE, caseData: caseData } }
export const changePasswordSuccess = (successMsg) => { return { type: CHANGE_PASSWORD_SUCCESS, successMsg: successMsg } }
export const changePasswordFailure = (errorMsg) => { return { type: CHANGE_PASSWORD_FAILURE, message: errorMsg } }
export const hideSnackBarAction = () => { return { type: HIDE_LOGIN_SNACKBAR } }

// RENDER COMPONETS USING SWITCH CASE
export const renderForgetPass = (caseData) => (dispatch) => {
    dispatch(returnProfile(caseData));
};

// POST LOGIN
export const addLogin = (loginData) => (dispatch) => {
    var tempSession = {};
    let axiosInstance = getAxiosInstance();

    dispatch(loginInProgress(loginData));
    return axiosInstance.post(constants.api.POST_LOGIN, {
        mobileNo: loginData.mobileNo,
        password: loginData.password,
    }).then(function (response) {
        tempSession = response.data;
        sessionStorage.setItem("User", JSON.stringify(tempSession));
        dispatch(loginSuccess(loginData));
    }).catch(function (error) {
        console.log(JSON.stringify(error));

        if(error && error.response && error.response.data && error.response.data.message)
        {
            dispatch(loginFailure(error, error.response.data.message));
        }
        else
        {
            dispatch(loginFailure(error, 'मोबाईल नं किंवा पासवर्ड चुकीचा आहे'));
        }
        
    });
};

// VERIFY MOBILE NUMBER
export const verifyMobNumber = (data) => (dispatch) => {
    let axiosInstance = getAxiosInstance();
    return axiosInstance.post(constants.api.POST_MOBILE_NUMBER, {
        mobileNo: data.mobileNo,
    }).then(function (response) {
        dispatch(mobVerifySuccess(response.data, "Verify mobile number successfuly"));
    }).catch(function (error) {
        dispatch(mobVerifyFailure(error.response && error.response.data && error.response.data.message));
    });
};

// VERIFY OTP 
export const verifyOtp = (data) => (dispatch) => {
    let axiosInstance = getAxiosInstance();
    return axiosInstance.post(constants.api.POST_OTP, {
        otp: data.otp,
        mobileNo: data.mobData.mobileNo,
    }).then(function (response) {

        if (response.status === 200) {
            dispatch(otpVerifySuccess(response.data, "OTP verify successfuly"));
        } else {
            dispatch(otpFailure(response.data.message))
        }

    }).catch(function (error) {
        dispatch(otpFailure(error.response && error.response.data && error.response.data.message));
    });
};

// change password
export const changePassword = (data) => (dispatch) => {
    let axiosInstance = getAxiosInstance();
    return axiosInstance.put(constants.api.CHANGE_PASS, {
        password: data.password,
        mobileNo: data.mobileNo,
    }).then(function (response) {
        dispatch(changePasswordSuccess("Change password successfuly"));
    }).catch(function (error) {
        dispatch(changePasswordFailure(error.response && error.response.data && error.response.data.message));
    });
};

// HIDE THE MESSAGE SNACKBAR
export const hideSnackBar = () => (dispatch) => {
    dispatch(hideSnackBarAction());
}

/**
 * Logout user account
 * Remove user data from seesion storage
 * Rest root redux state on logout.
 */
export const logOut = () => (dispatch) => {
    sessionStorage.removeItem('User');
    dispatch({ type: 'LOGOUT' })
}

export const initialState = {
    choice: null,
    inProgress: false,
    isAuthenticated: false,
    message: '',
    openSnacbar: false,
    toggle: 'toggel',
    mobData: '',
    otpData: '',
}

export default (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_PROGRESS:
            var login = action.loginData;
            return { ...state, login, inProgress: true };
        case LOGIN_SUCCESS:
            return { ...state, login, inProgress: false, isAuthenticated: true };
        case LOGIN_FAILURE:
            return { ...state, login, message: action.message, openSnacbar: true, inProgress: false, choice: null };
        case MOB_VERIFY_SUCCESS:
            return { ...state, mobData: action.mobData, message: action.successMsg, inProgress: false, openSnacbar: true, toggle: '' };
        case MOB_VERIFY_FAILURE:
            return { ...state, message: action.message, openSnacbar: true };
        case OTP_VERIFY_SUCCESS:
            return { ...state, openSnacbar: true, otpData: action.otpData, message: action.successMsg, choice: 'changePass' };
        case OTP_VERIFY_FAILURE:
            return { ...state, message: action.message, openSnacbar: true, toggle: '' };
        case CHANGE_PASSWORD_SUCCESS:
            return { ...state, message: action.message, openSnacbar: true, choice: null, toggle: 'toggel' };
        case CHANGE_PASSWORD_FAILURE:
            return { ...state, message: action.message, openSnacbar: true };
        case SEND_FORGET_CASE:
            return { ...state, choice: action.caseData, toggle: 'toggel', };
        case HIDE_LOGIN_SNACKBAR:
            return { ...state, openSnacbar: false };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/design-reducers.js